import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import {SoundEvent} from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import BetModel from "slotworks/model/bets/bet-model";

export function StartSpinCommand(): Contract<void> {
    Components.betBar.setBalance(GameState.getCurrentGame().startBalance);
    Components.betMenu.setBalance(GameState.getCurrentGame().startBalance);

    const record = GameState.getCurrentGame().getCurrentRecord();
    if ((record) && (record instanceof FreespinRecord || (record as SpinRecord).freespinsTriggered ||
            (record as any).inFreespins) || GameState.getCurrentGame().inFreespinsGame) {
        SoundManager.event(SoundEvent.start_freespin);
    } else {
		if((GameState.getCurrentGame().startBalance) > BetModel.getTotalBet()){
		    SoundManager.event(SoundEvent.start_spin);
		}
    }

    return Components.matrix.startTransition();
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/comms/start-spin-command.ts